module.exports = __webpack_public_path__ + "static/media/background01.7f614f49.jpg";